import { grey, orange } from "@material-ui/core/colors";
import React from "react";
import { defaults , Bar } from "react-chartjs-2";
import { colorGenerator } from "../../features/colorgenerator";
import { iconNameMapping } from '../../features/iconmapping';

function HeroRadar({ heroData, isDark }) {
  let hero = Object.keys(heroData)[0];
  defaults.global.defaultFontFamily = 'Archivo, sans-serif';
  let data = {
    labels: Object.keys(heroData[hero]),
    datasets: [
      {
        label: hero,
        data: Object.values(heroData[hero]),
        backgroundColor: colorGenerator(heroData[hero]),
      },
    ],
  };
  let options = {
    legend: {
      display: true,
      labels: {
        fontSize: 15,
        fontColor: isDark ? orange[500] : "black",
        boxWidth: 0,
      },
    },
    scales: {
      xAxes: [
        {
          ticks: {
            fontColor: isDark ? grey[300] : "black",
            fontSize: 13,
            fontStyle: 'bold'
          },
          gridLines: {
            display: false,
          }
        },
      ],
      yAxes: [
        {
          ticks: {
            fontColor: isDark ? grey[300] : "black",
            fontSize: 13,
            beginAtZero: true,
          },
          gridLines: {
            color: isDark ? grey['A700'] : grey['A300'],
          }
        },
      ],
    },
  };
  const imgname = iconNameMapping(hero).replace(/[\s-]/g, '_').replace(/'/g, '').toLowerCase()
  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
      <i className={`d2mh ${imgname}`}></i>
      <Bar data={data} options={options} /> 
    </div>
  );
}

export default HeroRadar;
